import { useAuthStore } from 'src/store/auth';

interface GuardianCardProps {
  firstName?: string;
  lastName?: string;
  memberId?: string | number;
  groupId?: string | number
}

export const GuardianCard = ({ firstName, lastName, memberId, groupId }: GuardianCardProps) => {
  const memberData = {
    planholder: 'ONE HEALTH BUSINESS ALLIANCE',
    network: 'VSP',
    planNumber: 'G-00077758',
    subscriber: `${firstName || ''} ${lastName || ''}`.trim() || '{Jane Doe}',
    memberId: memberId || '{0000000000000}',
  };

  return (
    <div className="relative aspect-[672/289] max-w-[672px] origin-center scale-60 md:scale-100 border border-[#e0e0e0] rounded-2xl system-font px-4">
      {/* Header Section */}

      {/* Main Content - Two Columns */}
      <div className="flex gap-8 px-4 py-10">
        {/* Left Column */}
        <div className="flex-1">
          <div className="flex items-center gap-4 pt-4">
            <img src="/images/guardian.png" alt="Guardian" className="h-12" />
          </div>
          <div className="text-base text-black mt-4">
            <span className="font-normal">Planholder</span>
          </div>
          <div className="text-base text-black font-bold">
            {memberData.planholder}
          </div>
          <div className="text-base text-black mt-4">
            <span className="font-normal">Network</span>
          </div>
          <div className="text-base text-black font-bold">
            {memberData.network}
          </div>
        </div>

        {/* Right Column */}
        <div className="flex-1 text-right mt-4">
          <div className="text-base text-black">
            <span className="font-normal">Plan number</span>
          </div>
          <div className="text-base text-black font-bold">
            {memberData.planNumber}
          </div>
          <div className="text-base text-black mt-4">
            <span className="font-normal">Subscriber</span>
          </div>
          <div className="text-base text-black font-bold">
            {memberData.subscriber}
          </div>
          <div className="text-base text-black mt-4">
            <span className="font-normal">Member ID</span>
          </div>
          <div className="text-base text-black font-bold">
            {memberData.memberId}
          </div>
        </div>
      </div>

      {/* Bottom spacing */}
      <div className="pb-4"></div>
    </div>
  );
};


